import { gql } from '@provision/graphql-client';
import { getStoredAttributeHooks } from './stored-attributes';

const ADDRESS_CUSTOM_ATTRIBUTES_FRAGMENT = gql`
  fragment AddressCustomAttributesFields on Address {
    id
    addressId
    customAttributes
  }
`;

const GET_ADDRESS_CUSTOM_ATTRIBUTES = gql`
  query GetAddressCustomAttributes($params: QueryParamsWithSearch) @entity(name: "Address") {
    getAddress(queryParams: $params) {
      records {
        id
        addressId
        customAttributes
      }
    }
  }
`;

const UPDATE_ADDRESS_CUSTOM_ATTRIBUTES_MUTATION = gql`
  mutation UpdateAddressCustomAttributes(
    $conditions: [ConditionInput]
    $data: AddressDataInput
  ) {
    updateAddress(conditions: $conditions, data: $data) {
      ...AddressCustomAttributesFields
    }
  }
  ${ADDRESS_CUSTOM_ATTRIBUTES_FRAGMENT}
`;

export const addressCustomAttributesConfig = getStoredAttributeHooks({
  typename: 'Address',
  idAttribute: 'addressId',
  fragment: ADDRESS_CUSTOM_ATTRIBUTES_FRAGMENT,
  fragmentName: 'AddressCustomAttributesFields',
  query: GET_ADDRESS_CUSTOM_ATTRIBUTES,
  queryRootField: 'getAddress',
  mutation: UPDATE_ADDRESS_CUSTOM_ATTRIBUTES_MUTATION,
});
